<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Contract3PLPage',

};
</script>

<style>

</style>
